export const EnvironmentNames = {
    prod:  'prod',
    preprod: 'preprod',
    qa: 'qa',
    int: 'int',
    dev: 'dev',
    mock: 'mock',
    qaaws: 'qaaws',
    local: 'local'
};